
import { TextInputField, Button, DropDownField, } from "../../../../helpers"
import Tooltip from "../../../../helpers/Tooltip"


const PositiveAdjDisplay = (props) => {

    const { sellerPOs, handleSellerPOsChange, GSTRates, handleSellerPOItem, isLoading } = props

    const handleSellerPOChange = (id, e) => {
        handleSellerPOsChange(id, e.target.name, e.target.value)
    }

    const handleSellerPOBtnClcik = (id, docNo) => {
        handleSellerPOItem(id, docNo)
    }


    return (
        <>
            {
                sellerPOs.map(eachSelPO => {
                    return (
                        <div key={`sellerPO-${eachSelPO.tempSellerPOId}`}>
                            <div className="flex flex-row p-0">
                                <div className="flex flex-column mb-2 lg:col-3 lg:mb-0">
                                    <label htmlFor="sellerPODocNo" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                        Seller PO No(optional)
                                        <Tooltip target=".seller-po-doc-no-info-icon" position="top" content="If seller PO Doc no is not provided, 15000000000000(dummy) as seller po doc no will be taken" />
                                        <i className="pi pi-info-circle seller-po-doc-no-info-icon ml-1"></i>
                                    </label>
                                    <TextInputField name="sellerPODocNo" id="sellerPODocNo" keyfilter={"pnum"} value={eachSelPO.sellerPODocNo} maxLength={15} onChange={(e) => { handleSellerPOChange(eachSelPO.tempSellerPOId, e) }} />
                                </div>
                                <div className="flex flex-column w-2rem align-items-center mt-4 px-0">
                                    <Button icon="pi pi-search" className="w-2rem" style={{ height: "35px" }} onClick={() => { handleSellerPOBtnClcik(eachSelPO.tempSellerPOId, eachSelPO.sellerPODocNo) }} disabled={eachSelPO.sellerPODocNo?.length !== 15 || isLoading} />
                                </div>
                                {/* <div className="flex flex-column  lg:col-3 lg:mb-0">
                                    <DropDownField name="sellerPIPunchId" labelText="Seller PIPunch No (optional)" optionLabel="sellerPINumber" optionValue="sellerPIPunchId" />
                                </div> */}
                                <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                    <TextInputField name="unitPrice" labelText="Price" value={eachSelPO.unitPrice} keyfilter={"pnum"} onChange={(e) => { handleSellerPOChange(eachSelPO.tempSellerPOId, e) }} disabled={eachSelPO.isValidSellerPO} required />
                                </div>
                                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                                    <DropDownField name="GSTRate" options={GSTRates} value={eachSelPO.GSTRate} labelText="GST" optionValue="GSTRate" optionLabel="GSTRateStr" onChange={(e) => { handleSellerPOChange(eachSelPO.tempSellerPOId, e) }} disabled={eachSelPO.isValidSellerPO} required />
                                </div>
                                <div className="flex flex-column col-12 lg:col-2 lg:mb-0">
                                    <TextInputField name="adjustedQty" labelText="Qty" keyfilter={"pnum"} value={eachSelPO.adjustedQty} onChange={(e) => { handleSellerPOChange(eachSelPO.tempSellerPOId, e) }} required />
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </>
    )
}

export default PositiveAdjDisplay